import { render, staticRenderFns } from "./DashboardSlider.vue?vue&type=template&id=b1463952&scoped=true"
import script from "./DashboardSlider.vue?vue&type=script&lang=js"
export * from "./DashboardSlider.vue?vue&type=script&lang=js"
import style0 from "./DashboardSlider.vue?vue&type=style&index=0&id=b1463952&prod&lang=sass&scoped=true"
import style1 from "./DashboardSlider.vue?vue&type=style&index=1&id=b1463952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1463952",
  null
  
)

export default component.exports